<template>
    <div v-if="active" class="modal is-active">
        <div class="modal-background" @click="close"></div>
        <div class="modal-card" style="width: fit-content;">
            <header class="modal-card-head">
                <p class="modal-card-title">Password Reset</p>
                <button class="delete" aria-label="close" @click="close"></button>
            </header>
            <section v-if="!sent" class="modal-card-body has-text-left">
                <p>Use this if you have forgotten your username or password.</p>
                <br>
                <form id="pwReset" @submit.prevent="submit">
                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label" for="email">E-Mail</label>
                        </div>
                        <div class="field-body">
                            <div class="control has-icons-left">
                                <input id="email" class="input" type="email" name="email" v-model="email" required>
                                <span class="icon is-small is-left">
                                    <i class="far fa-envelope"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="has-text-right">
                        <input class="button is-right" type="submit" value="Send E-Mail">
                    </div>
                </form>
            </section>
            <section v-else class="modal-card-body has-text-left">
                <p>Your E-mail is on the way.</p>
                <p>Please check your inbox for instructions to reset your password.</p>
            </section>
        </div>
    </div>
</template>

<script>
    import axios from "axios";

    export default {
        name: "PasswordResetModal",
        props: {
            active: {
                type: Boolean,
                required: true,
            },
            resetUrl: {
                type: String,
                required: true,
            },
        },
        data: () => ({
            'email': '',
            'sent': false,
        }),
        methods: {
            async submit() {
                let response = await axios.post(this.resetUrl, {
                    'email': this.email,
                });
                this.sent = true;
            },
            close() {
                this.$emit('update:active', false);
            },
        },
    }
</script>

<style scoped>

</style>